import styled from 'styled-components'

const SimpleA = styled.a.attrs(({ target }) => {
  if (target === '_blank') {
    return {
      rel: 'noopener noreferrer',
    }
  }

  return {}
})<{ href: string; textDecoration?: string; target?: '_blank'; rel?: string }>`
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  text-decoration: ${({ textDecoration = 'underline' }) => textDecoration};

  &:hover,
  &:link {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    text-decoration: ${({ textDecoration = 'underline' }) => textDecoration};
  }
`

export default SimpleA
